import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { markNotificationAsRead, deleteNotification } from "../../slices/notifications/reducer";
import NotificationItem from "./NotificationItem";
import { Badge, Button } from "reactstrap";
import "./NotificationList.scss";

const NotificationList = ({ notifications = [], isPreview = false }) => {
  const dispatch = useDispatch();
  const [expandedId, setExpandedId] = useState(null);

  const handleMarkAsRead = (e, notificationId) => {
    if (e) e.stopPropagation();
    dispatch(markNotificationAsRead(notificationId));
  };

  const handleDelete = (e, notificationId) => {
    if (e) e.stopPropagation();
    dispatch(deleteNotification(notificationId));
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const handleNavigate = (notification) => {
    // Mark as read when navigating
    if (!notification.isRead) {
      dispatch(markNotificationAsRead(notification.id));
    }

    // Navigate to notification detail page
    window.location.href = `/notifications?id=${notification.id}`;
  };

  const getTypeLabel = (type) => {
    const typeMap = {
      SERVICE_REQUEST: { label: "Service Request", color: "primary" },
      CALL_REQUEST: { label: "Call Request", color: "info" },
      MESSAGE: { label: "Message", color: "success" },
      REMINDER_UPDATE: { label: "Reminder", color: "warning" },
      APPOINTMENT_CONFIRMED: { label: "Appointment", color: "success" },
      APPOINTMENT_CANCELLED: { label: "Appointment", color: "danger" },
      SERVICE_COMPLETED: { label: "Completed", color: "success" },
      PAYMENT_RECEIVED: { label: "Payment", color: "success" },
      SYSTEM_ALERT: { label: "Alert", color: "danger" },
    };
    return typeMap[type] || { label: type, color: "secondary" };
  };

  if (notifications.length === 0) {
    return (
      <div className="notification-list-empty">
        <i className="ri-inbox-line"></i>
        <p>No notifications</p>
      </div>
    );
  }

  return (
    <div className="notification-list">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          isExpanded={expandedId === notification.id}
          onToggleExpand={() => toggleExpand(notification.id)}
          onMarkAsRead={handleMarkAsRead}
          onDelete={handleDelete}
          onNavigate={handleNavigate}
          typeInfo={getTypeLabel(notification.type)}
          isPreview={isPreview}
        />
      ))}
    </div>
  );
};

export default NotificationList;
